import React from 'react';

import { Button } from '@/components/ui/button';
import {
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';

import type { NpsResponseSummary } from './types';

interface SummaryStepProps {
  summary: NpsResponseSummary;
  onClose: () => void;
}

const SummaryStep: React.FC<SummaryStepProps> = ({ summary, onClose }) => (
  <>
    <DialogHeader>
      <DialogTitle>Obrigado pela sua participação!</DialogTitle>
      <DialogDescription>
        Sua resposta foi registrada e será usada para melhorar o serviço de
        transporte.
      </DialogDescription>
    </DialogHeader>
    <div className="rounded-md border p-4 text-sm">
      <p>
        {summary.scheduleCount === 1
          ? '1 horário avaliado'
          : `${summary.scheduleCount} horários avaliados`}
      </p>
      <p>Nota {summary.score}</p>
    </div>
    <DialogFooter>
      <Button onClick={onClose}>Voltar para o dashboard</Button>
    </DialogFooter>
  </>
);

export default SummaryStep;
